import React, { useState, useRef, createRef } from "react";
import { Input, NumericInputContainer } from "./NumericInput.styles";

const NumericInput = ({ length, onChange }) => {
  const [values, setValues] = useState(Array(length).fill(""));
  const inputRefs = useRef(Array.from({ length }, () => createRef()));

  const handleChange = (index, value) => {
    if (isNaN(value)) return;

    const newValues = [...values];
    newValues[index] = value;
    setValues(newValues);

    if (value && index < length - 1) {
      inputRefs.current[index + 1].current.focus();
    }

    onChange(newValues.join(""));
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !values[index] && index > 0) {
      inputRefs.current[index - 1].current.focus();
    }
  };

  return (
    <NumericInputContainer>
      {values.map((value, index) => (
        <Input
          key={index}
          ref={inputRefs.current[index]}
          type="text"
          maxLength="1"
          value={value}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
        />
      ))}
    </NumericInputContainer>
  );
};

export default NumericInput;
